import React, { useState, useEffect } from 'react'
import { useDispatch, connect } from 'react-redux'
import {
  pendingCommissionListFxn
} from '../actions'
import { Button, Col, Row, Select } from 'antd'
import { countryIds, filterOption } from '../../../components/_utils/appUtils'
import { listAllUniversities } from '../../university/actions/university'
import { listAllCountries } from '../../countries/actions/countries'
import { getUrlPushWrapper } from '../../../routes/routes'
import ClaimCommission from '../drawers/claimCommission'

let initFilter = {
  countryId: countryIds.uk,
  status: '',
  universityId: '',
  intake: '',
  countryList: [],
  universityList: []

}
let claimRecInit = {
  visible: false,
  record: [],
  commissionCurrency: '',
  universityId: ''
}
const { Option } = Select
const PendingCommission = (props) => {
  let [totalRecord, setTotalRecord] = useState(0)
  const [commissions, setCommissions] = useState([])
  const [filterState, setFilterState] = useState(initFilter)
  const [claimRecState, setClaimRecState] = useState(claimRecInit)
  const dispatch = useDispatch()
  const events = {

    showClaimRecDrawer: (record, currency, universityId) => {

      setClaimRecState({
        visible: true,
        record: record,
        commissionCurrency: currency,
        universityId: universityId
      })
    },
    hideClaimRecDrawer: () => {
      setClaimRecState({
        visible: false,
        record: [],
        commissionCurrency: '',
        universityId: ''
      })
      fetchData()
    },

    updateLocalFilter: (data) => {
      try {
        setFilterState({
          ...filterState,
          ...data
        })
      } catch (e) {
      }
    },
    searchFxn: async () => {
      let obj = {}
      let {
        countryId,
        universityId,
        intake,
        status
      } = filterState
      if (countryId) {
        obj.countryId = countryId
      }
      if (universityId) {
        obj.universityId = universityId
      }

      if (status) {
        obj.status = status
      }
      if (intake) {
        obj.intake = intake
      }
      dispatch(
        getUrlPushWrapper('commission.pendingCommission', {
          ...obj
        }))
      let respData = await dispatch(pendingCommissionListFxn(obj))
      if (respData.success) {
        setCommissions(respData.data)
        setTotalRecord(respData.totalClaimed)
      }
    },
    clearFxn: async () => {
      let obj = {}
      events.updateLocalFilter({
        countryId: '',
        universityId: ''
      })
      fetchData()
      dispatch(
        getUrlPushWrapper('commission.pendingCommission', {
          ...obj
        }))

    }
  }
  useEffect(() => {
    loadData.loadCountryList()
  }, [])
  const loadData = {
    loadCountryList: async () => {
      let params = {
        results: 5000,
        select: ['countryName'],
        sortField: 'countryName',
        sortOrder: 'ascend'
      }
      let { data } = await dispatch(listAllCountries(params))
      let obj = {}
      if (data && data.length) {
        obj.countryList = data
      }
      events.updateLocalFilter({ ...obj })
    },
    loadUniversityNameList: async (countryId) => {
      let params = {
        results: 5000,
        select: ['universityName'],
        sortField: 'universityName',
        sortOrder: 'ascend',
        regExFilters: ['universityName'],
        showUniversity: [true, false],
        universityCountry: countryId
      }
      let { data } = await dispatch(listAllUniversities(params))

      let obj = {
        universityId: ''
      }
      if (data && data.length) {
        obj.universityList = data
      }
      events.updateLocalFilter({ ...obj, countryId })
    }
  }
  const fetchData = async () => {
    let obj = {
      countryId: filterState.countryId || '',
      universityId: filterState.universityId || ''
    }
    let respData = await dispatch(pendingCommissionListFxn(obj))
    if (respData.success) {
      setCommissions(respData.data)
      setTotalRecord(respData.totalClaimed)
    }
  }
  useEffect(() => {
    fetchData()
  }, [])
  const FilterComponent = (
    <div className={'filter_box'}>
      <Row gutter={16}>
        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='sort-box-table custom-sort-box-new'>
            <Select name='Search By Country'
                    onChange={(item) => {
                      loadData.loadUniversityNameList(item)
                    }}
                    filterOption={filterOption}
                    placeholder='Country'
                    allowClear={false}
                    showSearch={false}
                    value={filterState.countryId || undefined}>
              {filterState.countryList && filterState.countryList.length ?
                filterState.countryList.map((item, key) => {
                  return (
                    <Option value={item._id} key={key}>{item.countryName}</Option>
                  )
                }) : null}
            </Select>
          </div>
        </Col>


        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='sort-box-table custom-sort-box-new'>
            <Select name='Search By University' onChange={(item) => {
              events.updateLocalFilter({ universityId: item })
            }}
                    filterOption={filterOption}
                    allowClear={true}
                    showSearch={true}
                    placeholder={'University'}
                    value={filterState.universityId || undefined}>
              {filterState.universityList && filterState.universityList.length ? filterState.universityList.map((item, key) => {
                return (
                  <Option value={item._id} key={key}>{item.universityName}</Option>
                )
              }) : null}
            </Select>
          </div>
        </Col>

        <Col md={6} sm={6} xs={8} lg={6}>
          <Button onClick={() => events.searchFxn()} className={'roundBtn'}>Search</Button>
          <Button onClick={() => events.clearFxn()} className={'roundBtn'}>
            Clear
          </Button>
        </Col>
      </Row>

    </div>
  )
  return (
    <div className={'row mt-4'}>
      <div className='col-lg-12'>
        <div className='card'>
          <div className='table-head d-flex align-items-center'>
            <h5>To Be Claimed: ({totalRecord || 0})</h5>
          </div>
          <div className='card-body table-responsive'>
            {FilterComponent}


            {commissions.length > 0 &&
            (
              <>
                <div className='card-pane-new listing-section w-100 direct-uni-box mt-4'>
                  <ul className={'count flex-wrap'}>
                    {commissions.map((item, index) => {
                      return (
                        <>
                          <li className={'canadaDirectUniCount canadaDirectUniBox'} key={index}>
                            <div className='innerBox' onClick={() => {
                              events.showClaimRecDrawer(item, item.currency, item.universityId)
                            }}>
                              <div className={'commission_list_grid'}>
                                <img src={item && item.smallLogo && item.smallLogo.url ? item.smallLogo.url : ''}
                                     alt='University Logo'
                                     className='rounded-circle'
                                />
                                <div className='university-name'>
                                  {item && item.universityName}
                                </div>
                                <div className={'count'}>
                                  {item.commissionCount}
                                </div>
                              </div>

                            </div>
                          </li>
                        </>
                      )
                    })}

                  </ul>

                </div>

              </>
            )}

          </div>
        </div>
      </div>
      {claimRecState.visible ?
        <ClaimCommission
          visible={claimRecState.visible}
          onClose={events.hideClaimRecDrawer}
          data={claimRecState.record}
          commissionCurrency={claimRecState.commissionCurrency}
          universityId={claimRecState.universityId}
        /> : null}
    </div>
  )
}

const mapStateToProps = ({ global, router }) => ({
  currentUser: global.currentUser
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingCommission)
